import type { MailboxInfo } from 'owa-client-types';
import { lazyCreateNewFolder } from 'owa-folder-createnew';
import { lazyCreateNewGroupFolder } from 'owa-group-folder-tree-actions';

export function createNewFolder(
    displayName: string,
    parentId: string,
    mailboxInfo: MailboxInfo
): Promise<string | null> {
    return lazyCreateNewFolder.importAndExecute({
        parentId,
        displayName,
        mailboxInfo,
    });
}

export function createNewGroupFolder(
    displayName: string,
    parentId: string,
    mailboxInfo: MailboxInfo
): Promise<string | null> {
    return lazyCreateNewGroupFolder.importAndExecute(
        mailboxInfo?.mailboxSmtpAddress,
        displayName.trim(),
        parentId
    );
}
